export default "__VITE_ASSET__BGmvS5a9__"